/**
 * Utility function to display user types consistently across the application
 * Internal users are displayed as "New School"
 * Supabase users are displayed as "Old School"
 */

export const getUserTypeDisplayName = (userType: 'supabase' | 'internal' | 'unknown' | string | undefined): string => {
  if (!userType) return 'Unknown';
  
  switch (userType.toLowerCase()) {
    case 'internal':
      return 'New School';
    case 'supabase':
      return 'Old School';
    default:
      return 'Unknown';
  }
};

export const getUserTypeBadgeVariant = (userType: 'supabase' | 'internal' | 'unknown' | string | undefined): 'secondary' | 'outline' => {
  if (!userType) return 'outline';
  
  switch (userType.toLowerCase()) {
    case 'supabase':
      return 'secondary';
    case 'internal':
      return 'outline';
    default:
      return 'outline';
  }
};